import type {
  BulkEntityId,
} from './types';

const ENTITY_PATH_ENUM = {
  'Model.ShoppingCampaign': 'Campaigns',
  'Model.Campaign': 'Campaigns',
  'Model.AdGroup': 'AdGroups',
} as Record<string, string>;

export const getSkipEntityCallPaths = (entityName: string, ids: BulkEntityId[]) => {
  const entityPath = entityName.includes('Model') ? ENTITY_PATH_ENUM[entityName] : `${entityName}s`;
  if (!entityPath) {
    return [];
  }
  return ids.map((id: BulkEntityId) => `${entityPath}(${id})`);
};
